// Shared visual language for the Internal Libraries docs UI (Mintlify/Tremor-style).
// Inter (sans-serif) + JetBrains Mono (code) are both loaded in public/index.html.

export const DOCS_FONT =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif";

export const DOCS_MONO_FONT =
  "'JetBrains Mono', ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, monospace";

export const docs = {
  font: DOCS_FONT,
  monoFont: DOCS_MONO_FONT,
  // Text
  textStrong: '#0f172a', // titles
  text: '#334155', // body
  textMuted: '#64748b', // secondary
  textFaint: '#94a3b8', // labels / hints
  // Surfaces & lines
  bg: '#ffffff',
  bgSubtle: '#f8fafc',
  border: '#e9edf3',
  borderStrong: '#dfe4ec',
  // Selected nav item
  selectedBg: '#0f172a',
  selectedText: '#ffffff',
  // Code / terminal block
  codeBg: '#0f172a',
  codeText: '#e2e8f0',
  // Chips
  chipBg: '#f1f5f9',
  chipBorder: '#e2e8f0',
  typeChipBg: '#eef2ff',
  typeChipText: '#4338ca',
  // Accents
  reqBg: '#fef3c7',
  reqText: '#92400e',
  ready: '#10b981', // status dot
};
